// extracted by mini-css-extract-plugin
module.exports = {"ImageList":"BriefImageStyles2_ImageList__kOVvM"};